import { useEffect, useState } from "react";
import axios from "axios";

export default function Finansijeklijenti() {

  const [users, setUsers] = useState([]);
  //const [msg, setMsg] = useState("");

  const token = localStorage.getItem("token");
  //search 
  const [search, setSearch] = useState("");


  const loadUsers = () => {
    axios
      .get(`/api/finansijeklijenti` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setUsers(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadUsers();
  }, []);


  // filtriraj samo ako je activeTab === "users"
  // Filtrirana lista po search inputu
  const filteredUsers = users.filter(u =>
    u.ime.toLowerCase().includes(search.toLowerCase()) ||
    String(u.klijentID).includes(search) ||
    u.adresa.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase()) ||
    u.grad.toLowerCase().includes(search.toLowerCase()) ||
    u.telefon.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Klijenti</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="table table-dark mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Ime</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Grad</th>
          </tr>
        </thead>

        <tbody>
          {filteredUsers.map(u => (
            <tr key={u.klijentID}>
              <td>{u.klijentID}</td>
              <td>{u.ime}</td>
              <td>{u.email}</td>
              <td>{u.telefon}</td>
              <td>{u.grad}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}